import { createFileRoute } from '@tanstack/react-router';
import Signup from '@/pages/Signup';

export interface SignupSearch {
  token?: string;
  error?: string;
}

export const Route = createFileRoute('/_public/signup')({
  validateSearch: (raw: Record<string, unknown>): SignupSearch => ({
    token: (raw.token as string) ?? undefined,
    error: (raw.error as string) ?? undefined,
  }),
  component: Signup,
});
